var exports = {
  "k": "xdde3148b--ab0971--container",
  "S": "xdde3148b--ab0971--image",
};

module.exports = exports;
